var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _g, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCodapCypress(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 4000,
    height: 3000,
    viewBox: "0 0 4000 3000",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M741.448 442.631H3283.15C3371.56 442.631 3443.89 512.732 3443.89 598.423V2341.38H580.71V598.423C580.71 512.732 653.038 442.631 741.448 442.631ZM2012.3 511.07C1998.43 511.07 1987.19 521.962 1987.19 535.4C1987.19 548.838 1998.43 559.729 2012.3 559.729C2026.17 559.729 2037.42 548.838 2037.42 535.4C2037.42 521.962 2026.17 511.07 2012.3 511.07ZM739.604 651.981H3285V2190.45H739.604V651.981Z",
    fill: "#373F47"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3285 651.982H739.603V2190.45H3285V651.982Z",
    fill: "#C0C0C0",
    stroke: "black",
    strokeWidth: 0.66624,
    strokeMiterlimit: 2.61313
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M315.002 2371.52H3685V2497.09C3685 2530.24 3657.88 2557.37 3624.72 2557.37H375.281C342.126 2557.37 315.002 2530.24 315.002 2497.09V2371.52Z",
    fill: "#373F47"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2223.37 1333.76C2435.78 1348.35 2644.92 1362.71 2855.75 1377.19C2853.06 1233.24 2851 1092.18 2847.96 951.053C2837.92 951.053 2830.55 950.707 2823.21 951.113C2792.47 952.825 2761.75 954.933 2731.01 956.588C2672.59 959.726 2614.14 962.505 2555.72 965.715C2478.25 969.972 2400.79 974.493 2323.32 978.907C2295.83 980.472 2268.35 982.049 2239.51 983.696C2234.12 1100.72 2228.8 1216.07 2223.37 1333.76ZM2840.99 935.115C2852.74 934.502 2862.68 943.746 2863.15 955.49C2863.81 971.61 2864.44 986.78 2864.69 1001.96C2866.29 1098.03 2867.61 1194.1 2869.17 1290.17C2869.62 1317.87 2870.59 1345.56 2871.2 1373.27C2871.6 1390.89 2868.49 1393.88 2850.94 1392.68C2744 1385.34 2637.05 1377.96 2530.11 1370.59C2440.99 1364.45 2351.87 1358.32 2262.75 1352.15C2249.85 1351.25 2236.95 1350.26 2224.07 1349.07C2210.19 1347.78 2208.13 1346.08 2208.52 1331.94C2209.28 1304.24 2210.81 1276.57 2212.1 1248.89C2216.08 1162.79 2220.04 1076.67 2224.15 990.57C2225.14 969.81 2226.2 969.026 2246.56 967.932C2339.46 962.929 2432.35 957.933 2525.25 952.873C2615.07 947.982 2704.88 943.033 2794.7 938.051C2810.07 937.2 2825.43 935.967 2840.81 935.125C2840.87 935.123 2840.93 935.119 2840.99 935.115ZM2715.09 1151.92C2721.05 1158.31 2721.02 1168.24 2714.84 1174.42C2713.82 1175.43 2712.79 1176.41 2711.73 1177.34C2672.14 1212.12 2632.44 1246.77 2592.74 1281.42C2589.95 1283.87 2587.27 1287.06 2583.95 1288.14C2580.52 1289.25 2574.88 1289.73 2572.87 1287.77C2568.87 1283.87 2570.07 1278.68 2574.92 1275.16C2576.92 1273.71 2579.35 1272.8 2581.19 1271.19C2621.8 1235.74 2662.35 1200.23 2704.41 1163.42C2693.99 1153.03 2684.53 1146.15 2673.43 1135.95C2646.5 1111.22 2628.52 1090.72 2595.38 1061.02C2592.37 1058.32 2589.87 1055.25 2586.89 1052.6C2582.52 1048.69 2578.12 1044.3 2583.79 1038.73C2589.45 1033.18 2593.98 1038.08 2598.04 1041.86C2613.48 1056.21 2628.81 1070.67 2644.19 1085.08C2666.35 1105.84 2688.58 1126.54 2710.64 1147.42C2712.17 1148.86 2713.63 1150.36 2715.09 1151.92ZM2328.26 1181.62C2335.73 1186.75 2340.88 1190.8 2346.49 1194.06C2387.88 1218.02 2429.35 1241.83 2470.8 1265.67C2473.46 1267.2 2476.16 1268.65 2478.86 1270.1C2483.66 1272.69 2487.54 1276.66 2483.78 1281.64C2482.07 1283.91 2476.25 1284.06 2472.54 1283.52C2469.12 1283.02 2465.98 1280.38 2462.8 1278.55C2419.72 1253.84 2376.65 1229.11 2333.59 1204.36C2330.41 1202.53 2327 1200.89 2324.26 1198.51C2312.85 1188.6 2311.77 1176.27 2321.83 1165.37C2361.36 1122.5 2401.08 1079.8 2440.77 1037.08C2442.83 1034.86 2445.02 1032.14 2447.68 1031.28C2450.11 1030.49 2454.18 1030.98 2455.82 1032.62C2457.41 1034.22 2458.05 1038.67 2456.94 1040.67C2454.62 1044.87 2451.03 1048.41 2447.71 1051.99C2412.66 1089.81 2377.56 1127.57 2342.5 1165.39C2338.38 1169.84 2334.49 1174.5 2328.26 1181.62Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M881.632 1774.23H2156.81V843.212H881.632V1774.23Z",
    fill: "#DCE9FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M930.74 1732.36H2114.93V885.083H930.74V1732.36ZM926.452 1736.65H2119.22V880.8H926.452V1736.65Z",
    fill: "#24B9CD"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M929.343 1594.97H2117.78V1590.63H929.343V1594.97Z",
    fill: "#4965CC"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M929.343 1451.85H2117.78V1447.51H929.343V1451.85Z",
    fill: "#4965CC"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M929.343 1310.17H2117.78V1305.83H929.343V1310.17Z",
    fill: "#4965CC"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M929.343 1168.49H2117.78V1164.15H929.343V1168.49Z",
    fill: "#4965CC"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M929.343 1026.81H2117.78V1022.48H929.343V1026.81Z",
    fill: "#4965CC"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1916.81 1733.75H1921.15V882.245H1916.81V1733.75Z",
    fill: "#4965CC"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1718.74 1733.75H1723.08V882.245H1718.74V1733.75Z",
    fill: "#4965CC"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1520.67 1733.75H1525.01V882.245H1520.67V1733.75Z",
    fill: "#4965CC"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1322.6 1733.75H1326.93V882.245H1322.6V1733.75Z",
    fill: "#4965CC"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1125.97 1733.75H1130.31V882.245H1125.97V1733.75Z",
    fill: "#4965CC"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1472.85 1531.36H1472.81C1470.56 1531.34 1468.5 1530.11 1467.43 1528.14L1234.4 1100.75L1034.43 1366.69C1032.38 1369.42 1028.51 1369.97 1025.78 1367.92C1023.06 1365.87 1022.51 1362 1024.56 1359.28L1230.3 1085.66C1231.56 1083.98 1233.57 1083.06 1235.68 1083.21C1237.78 1083.36 1239.65 1084.57 1240.65 1086.42L1472.94 1512.46L1650.03 1198.57C1651.09 1196.69 1653.06 1195.5 1655.23 1195.43C1657.39 1195.38 1659.43 1196.45 1660.6 1198.27L1794.64 1406.82L2012.51 1085.9C2014.43 1083.08 2018.28 1082.35 2021.1 1084.26C2023.92 1086.18 2024.65 1090.01 2022.73 1092.84L1799.61 1421.48C1798.44 1423.2 1796.47 1424.21 1794.42 1424.19C1792.35 1424.16 1790.43 1423.1 1789.3 1421.35L1655.75 1213.56L1478.23 1528.22C1477.13 1530.16 1475.08 1531.36 1472.85 1531.36Z",
    fill: "#D5962F"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_0_1",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2599,
    y: 1475,
    width: 560,
    height: 399
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2599.65 1475.95H3158.7V1873.82H2599.65V1475.95Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_0_1)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3158.7 1497.52L3158.41 1852.71C3158.41 1864.36 3148.89 1873.85 3137.15 1873.82L2921.58 1873.67L2889.34 1873.64L2836.47 1873.61L2620.86 1873.43C2609.16 1873.43 2599.63 1863.95 2599.65 1852.25L2599.94 1497.07C2599.94 1485.41 2609.46 1475.92 2621.17 1475.95L3137.46 1476.35C3149.2 1476.34 3158.69 1485.83 3158.7 1497.52Z",
    fill: "#F3C0FF"
  }))), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2921.57 1873.68L2928.52 1960.82L2829.38 1960.74L2830.28 1949.72L2836.47 1873.61L2889.34 1873.64L2921.57 1873.68Z",
    fill: "#FF8EDE"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3031.77 1986.2L3031.41 1986.59C3030.1 1987.9 3029.18 1988.84 3026.95 1989.48C3021.76 1990.95 3009.42 1990.88 2968.5 1990.6C2927.06 1990.32 2857.73 1989.88 2736.58 1990.3C2732.63 1990.31 2728.87 1988.77 2726.09 1985.98C2723.26 1983.16 2721.72 1979.44 2721.74 1975.48C2721.73 1967.31 2728.43 1960.67 2736.61 1960.67L2829.38 1960.74L2928.52 1960.82L3021.3 1960.89C3027.42 1960.9 3032.68 1964.42 3035.02 1970.07C3037.33 1975.72 3036.12 1981.91 3031.77 1986.2Z",
    fill: "#6280FF"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3158.44 1809.56L3158.41 1852.7C3158.4 1864.38 3148.88 1873.85 3137.15 1873.84L2620.87 1873.44C2609.14 1873.43 2599.64 1863.95 2599.65 1852.26L2599.68 1809.13L3158.44 1809.56Z",
    fill: "#FF93DE"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3031.77 1986.2L3031.41 1986.59C3030.1 1987.9 3029.18 1988.84 3026.95 1989.48C3021.76 1990.95 3009.42 1990.88 2968.5 1990.6C2927.06 1990.32 2857.73 1989.88 2736.58 1990.3C2732.63 1990.31 2728.87 1988.77 2726.09 1985.98C2723.26 1983.16 2721.72 1979.44 2721.74 1975.48C2721.73 1967.31 2728.43 1960.67 2736.61 1960.67L2829.38 1960.74L2928.52 1960.82L3021.3 1960.89C3027.42 1960.9 3032.68 1964.42 3035.02 1970.07C3037.33 1975.72 3036.12 1981.91 3031.77 1986.2Z",
    fill: "#FB0EB2"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3130.73 1507.42L3130.51 1778.43C3130.51 1782.04 3127.57 1784.97 3123.94 1784.97L2634.22 1784.58C2630.6 1784.58 2627.66 1781.66 2627.66 1778.04L2627.87 1507.03C2627.87 1503.45 2630.82 1500.53 2634.44 1500.53L3124.17 1500.9C3127.79 1500.91 3130.73 1503.84 3130.73 1507.42Z",
    fill: "#EBE7FF"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2892.63 1840.94C2892.62 1848.42 2886.53 1854.48 2879.03 1854.47C2871.52 1854.46 2865.45 1848.4 2865.45 1840.92C2865.46 1833.45 2871.54 1827.39 2879.05 1827.4C2886.55 1827.4 2892.63 1833.47 2892.63 1840.94Z",
    fill: "#FB0EB2"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2883.41 1756.15C2824.64 1756.15 2777 1708.5 2777 1649.74C2777 1590.97 2824.64 1543.33 2883.41 1543.33C2942.18 1543.33 2989.82 1590.97 2989.82 1649.74C2989.82 1708.5 2942.18 1756.15 2883.41 1756.15Z",
    fill: "white"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2877.11 1720.68L2800.65 1660.01L2827.27 1624.88L2870.68 1659.33L2926.97 1590.62L2960.26 1619.18L2877.11 1720.68Z",
    fill: "#FF93DE"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCodapCypress);
export default __webpack_public_path__ + "static/media/codap-cypress.4f7aca608b434b2314079a97294f0256.svg";
export { ForwardRef as ReactComponent };